import { Icon } from "@chakra-ui/react";

const CalendarIcon = (props: any) => (
  <Icon viewBox="0 0 34 34" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6875 7C11.9361 7 12.1746 7.09877 12.3504 7.27459C12.5262 7.4504 12.625 7.68886 12.625 7.9375V9.5H21.375V7.9375C21.375 7.68886 21.4738 7.4504 21.6496 7.27459C21.8254 7.09877 22.0639 7 22.3125 7C22.5611 7 22.7996 7.09877 22.9754 7.27459C23.1512 7.4504 23.25 7.68886 23.25 7.9375V9.5H23.5625C24.4742 9.5 25.3485 9.86216 25.9932 10.5068C26.6378 11.1515 27 12.0258 27 12.9375V23.5625C27 24.4742 26.6378 25.3485 25.9932 25.9932C25.3485 26.6378 24.4742 27 23.5625 27H10.4375C9.52582 27 8.65148 26.6378 8.00682 25.9932C7.36216 25.3485 7 24.4742 7 23.5625V12.9375C7 12.0258 7.36216 11.1515 8.00682 10.5068C8.65148 9.86216 9.52582 9.5 10.4375 9.5H10.75V7.9375C10.75 7.68886 10.8488 7.4504 11.0246 7.27459C11.2004 7.09877 11.4389 7 11.6875 7ZM10.4375 13.875C9.575 13.875 8.875 14.575 8.875 15.4375V23.5625C8.875 24.425 9.575 25.125 10.4375 25.125H23.5625C24.425 25.125 25.125 24.425 25.125 23.5625V15.4375C25.125 14.575 24.425 13.875 23.5625 13.875H10.4375Z"
      fill="currentColor"
    />
  </Icon>
);

export default CalendarIcon;
